import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Shield, X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-brand-darker border-t border-white/5 py-12" data-id="element-48">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-49">
          <div className="flex items-center gap-2 text-white/50 mb-6" data-id="element-50">
            <Shield size={20} data-id="element-51" />
            <span className="text-sm font-medium uppercase tracking-wider" data-id="element-52">
              Pago 100% Seguro y Cifrado
            </span>
          </div>

          <div className="text-2xl font-black tracking-tighter text-white/20 mb-6" data-id="element-53">
            INSTA-BRAND <span className="text-brand-cyan/20" data-id="element-54">AI</span>
          </div>

          <div className="flex items-center gap-6 mb-6" data-id="element-55">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-brand-gray/60 hover:text-brand-cyan transition-colors underline underline-offset-4 decoration-white/10 hover:decoration-brand-cyan/50" data-id="element-56">
              Política de Privacidad
            </button>
            <span className="text-white/10" data-id="element-57">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-brand-gray/60 hover:text-brand-cyan transition-colors underline underline-offset-4 decoration-white/10 hover:decoration-brand-cyan/50" data-id="element-58">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-brand-gray/50 text-sm" data-id="element-59">
            &copy; {new Date().getFullYear()} Insta-Brand AI. Todos los derechos
            reservados.
            <br data-id="element-60" />
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-61">
        {activeModal && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-62">
            {/* Backdrop */}
            <motion.div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} data-id="element-63" />

            {/* Modal Content */}
            <motion.div className="relative w-full max-w-2xl max-h-[80vh] overflow-y-auto glass-card rounded-2xl border-brand-cyan/20 shadow-[0_0_40px_rgba(0,240,255,0.1)]" initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} data-id="element-64">
              {/* Top gradient bar */}
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-cyan via-brand-purple to-brand-cyan rounded-t-2xl" data-id="element-65" />

              {/* Close button */}
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 p-2 rounded-full bg-white/5 hover:bg-white/10 text-white/60 hover:text-white transition-colors z-10" data-id="element-66">
                <X size={20} data-id="element-67" />
              </button>

              <div className="p-8 md:p-10" data-id="element-68">
                {activeModal === 'privacy' && <PrivacyContent data-id="element-69" />}
                {activeModal === 'terms' && <TermsContent data-id="element-70" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <div className="space-y-6" data-id="element-71">
      <h2 className="text-3xl font-bold text-white" data-id="element-72">Política de Privacidad</h2>
      <p className="text-sm text-brand-cyan" data-id="element-73">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <div className="space-y-4 text-brand-gray leading-relaxed" data-id="element-74">
        <section data-id="element-75">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-76">
            1. Información que Recopilamos
          </h3>
          <p data-id="element-77">
            Recopilamos información personal que usted nos proporciona
            directamente al realizar una compra, incluyendo su nombre, dirección
            de correo electrónico y datos de pago. Los datos de pago son
            procesados de forma segura por nuestro procesador de pagos y no
            almacenamos información de tarjetas de crédito en nuestros
            servidores.
          </p>
        </section>

        <section data-id="element-78">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-79">
            2. Uso de la Información
          </h3>
          <p data-id="element-80">Utilizamos su información personal para:</p>
          <ul className="list-disc list-inside ml-4 mt-2 space-y-1" data-id="element-81">
            <li data-id="element-82">
              Procesar y entregar su compra del producto digital Insta-Brand AI.
            </li>
            <li data-id="element-83">Enviar confirmaciones de compra y acceso al producto.</li>
            <li data-id="element-84">Proporcionar soporte al cliente relacionado con su compra.</li>
            <li data-id="element-85">
              Enviar actualizaciones importantes sobre el producto adquirido.
            </li>
          </ul>
        </section>

        <section data-id="element-86">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-87">
            3. Protección de Datos
          </h3>
          <p data-id="element-88">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger su información personal contra acceso no autorizado,
            alteración, divulgación o destrucción. Todas las transacciones se
            realizan a través de conexiones cifradas (SSL/TLS).
          </p>
        </section>

        <section data-id="element-89">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-90">
            4. Cookies y Tecnologías de Seguimiento
          </h3>
          <p data-id="element-91">
            Nuestro sitio web puede utilizar cookies y tecnologías similares
            para mejorar la experiencia del usuario, analizar el tráfico del
            sitio y personalizar el contenido. Usted puede configurar su
            navegador para rechazar cookies, aunque esto podría afectar la
            funcionalidad del sitio.
          </p>
        </section>

        <section data-id="element-92">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-93">
            5. Compartir Información
          </h3>
          <p data-id="element-94">
            No vendemos, intercambiamos ni transferimos su información personal
            a terceros, excepto a proveedores de servicios de confianza que nos
            ayudan a operar nuestro sitio web y procesar pagos, siempre que
            dichas partes acuerden mantener esta información confidencial.
          </p>
        </section>

        <section data-id="element-95">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-96">
            6. Sus Derechos
          </h3>
          <p data-id="element-97">
            Usted tiene derecho a acceder, rectificar o eliminar su información
            personal en cualquier momento. También puede solicitar la
            portabilidad de sus datos o retirar su consentimiento para el
            procesamiento de datos.
          </p>
        </section>
      </div>
    </div>;
}
function TermsContent() {
  return <div className="space-y-6" data-id="element-98">
      <h2 className="text-3xl font-bold text-white" data-id="element-99">Términos y Condiciones</h2>
      <p className="text-sm text-brand-cyan" data-id="element-100">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <div className="space-y-4 text-brand-gray leading-relaxed" data-id="element-101">
        <section data-id="element-102">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-103">
            1. Aceptación de los Términos
          </h3>
          <p data-id="element-104">
            Al acceder y utilizar este sitio web y adquirir el producto digital
            Insta-Brand AI, usted acepta estar sujeto a estos Términos y
            Condiciones. Si no está de acuerdo con alguna parte de estos
            términos, no debe utilizar nuestro sitio web ni adquirir nuestros
            productos.
          </p>
        </section>

        <section data-id="element-105">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-106">
            2. Descripción del Producto
          </h3>
          <p data-id="element-107">
            Insta-Brand AI es un producto digital educativo que incluye guías,
            plantillas y recursos para la creación de contenido digital
            utilizando herramientas de inteligencia artificial. El producto se
            entrega en formato digital inmediatamente después de la compra.
          </p>
        </section>

        <section data-id="element-108">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-109">
            3. Licencia de Uso
          </h3>
          <p data-id="element-110">
            Al adquirir Insta-Brand AI, usted recibe una licencia personal, no
            transferible y no exclusiva para utilizar el contenido del producto.
            Queda prohibida la reproducción, distribución, reventa o
            compartición del material con terceros sin autorización expresa.
          </p>
        </section>

        <section data-id="element-111">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-112">
            4. Política de Pagos
          </h3>
          <p data-id="element-113">
            El precio del producto es un pago único de $27 USD. Todos los pagos
            se procesan de forma segura. Los precios pueden cambiar sin previo
            aviso, pero los cambios no afectarán a las compras ya realizadas.
          </p>
        </section>

        <section data-id="element-114">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-115">
            5. Resultados y Garantías
          </h3>
          <p data-id="element-116">
            Los resultados pueden variar según el esfuerzo, dedicación y
            aplicación individual de cada usuario. No garantizamos resultados
            financieros específicos. El producto proporciona herramientas y
            conocimientos educativos; el éxito depende de la implementación
            individual.
          </p>
        </section>

        <section data-id="element-117">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-118">
            6. Propiedad Intelectual
          </h3>
          <p data-id="element-119">
            Todo el contenido del producto Insta-Brand AI, incluyendo textos,
            gráficos, plantillas y metodologías, está protegido por derechos de
            autor. Cualquier uso no autorizado constituye una violación de estos
            términos y puede resultar en acciones legales.
          </p>
        </section>

        <section data-id="element-120">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-121">
            7. Limitación de Responsabilidad
          </h3>
          <p data-id="element-122">
            En ningún caso seremos responsables por daños indirectos,
            incidentales, especiales o consecuentes que resulten del uso o la
            imposibilidad de uso del producto. Nuestra responsabilidad total no
            excederá el monto pagado por el producto.
          </p>
        </section>

        <section data-id="element-123">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-124">
            8. Modificaciones
          </h3>
          <p data-id="element-125">
            Nos reservamos el derecho de modificar estos Términos y Condiciones
            en cualquier momento. Las modificaciones entrarán en vigor
            inmediatamente después de su publicación en el sitio web. El uso
            continuado del producto después de dichos cambios constituye su
            aceptación de los nuevos términos.
          </p>
        </section>
      </div>
    </div>;
}